import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ListPage } from "./pages/List";
import { DetailPage } from "./pages/Detail";
import { SearchPage } from "./pages/Search";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <div className="shell">
        <Routes>
          <Route path="/" element={<ListPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/transcriptions/:id" element={<DetailPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  </StrictMode>,
);
